import { queryClient } from 'src/config/request';
import { contentListQueries } from 'src/modules/contentList/queries';
export class ModuleCacheUpdater {
    static updateTotalPagesAfterPageReorder(moduleId, targetModuleId, extra) {
        queryClient.setQueryData(contentListQueries.getModules({ extra }).queryKey, (oldData) => {
            return oldData?.map((module) => {
                if (module.id === targetModuleId) {
                    return { ...module, totalPages: module.totalPages + 1 };
                }
                if (module.id === moduleId) {
                    return { ...module, totalPages: Math.max(module.totalPages - 1, 0) };
                }
                return module;
            });
        });
    }
    static insertModule({ moduleId, isUpdate, payload }) {
        queryClient.setQueryData(contentListQueries.getModules({ extra: payload.extra }).queryKey, (oldData) => {
            if (!oldData)
                return;
            const baseModuleData = {
                id: moduleId,
                name: payload.name,
                extra: payload.extra,
                classes: payload.classes,
                paidModule: payload.paidModule,
                publicModule: payload.publicModule
            };
            if (isUpdate) {
                return oldData.map((module) => module.id === moduleId ? { ...module, ...baseModuleData } : module);
            }
            const newModule = {
                ...baseModuleData,
                totalPages: 0,
                hotPassCost: null,
                purchaseData: null,
                order: (oldData[oldData.length - 1]?.order ?? 0) + 1
            };
            return [...oldData, newModule];
        });
    }
    static updateTotalPages({ moduleId, isExtraModule, totalPages }) {
        queryClient.setQueryData(contentListQueries.getModules({ extra: isExtraModule }).queryKey, (oldData) => {
            if (!oldData)
                return;
            return oldData.map((module) => module.id === moduleId
                ? {
                    ...module,
                    totalPages: Math.max(0, totalPages(module.totalPages))
                }
                : module);
        });
    }
    static delete(moduleIds, extra) {
        queryClient.setQueryData(contentListQueries.getModules({ extra }).queryKey, (oldData) => oldData?.filter((module) => !moduleIds.includes(module.id)));
    }
}
